import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarCpfCinResponsavelState } from './types';

export const INITIAL_STATE: ConsultarCpfCinResponsavelState = {
	status: 0,
	data: null,
	dataError: null,
	cpfRequest: null,
	instanceRequest: undefined,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarCpfCinResponsavelState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CPF_CIN_RESPONSAVEL_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.instanceRequest = action.instanceRequest;
				draft.cpfRequest = action.payload;
				break;
			}
			case Types.CONSULTAR_CPF_CIN_RESPONSAVEL_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}
			case Types.CONSULTAR_CPF_CIN_RESPONSAVEL_FAILURE: {
				draft.status = action.payload.status === 204 ? 204 : 400;
				draft.data = INITIAL_STATE.data;
				draft.dataError = action.payload.data;
				break;
			}
			case Types.CONSULTAR_CPF_CIN_RESPONSAVEL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				draft.instanceRequest = INITIAL_STATE.instanceRequest;
				draft.cpfRequest = INITIAL_STATE.cpfRequest;
				break;
			}

			default:
		}
		return draft;
	});
}
